module.exports = __webpack_public_path__ + "img/E_2_correct.2a9d195f.png";